import React from 'react';
import PropTypes from 'prop-types';

import {HtmlParser} from '~/src/components/parser/HtmlParser';

const supportedProps = ['className', 'data-testid'];

const HtmlText = ({as, htmlText, ...additionalProps}) => {
    if (!htmlText) {
        return null;
    }

    const props = supportedProps.reduce((acc, prop) => {
        acc[prop] = additionalProps[prop];
        return acc;
    }, {});

    if (as) {
        const HtmlElement = as;
        return (
            <HtmlElement {...props}>
                <HtmlParser html={htmlText} />
            </HtmlElement>
        );
    }

    return <HtmlParser html={htmlText} additionalProps={props} />;
};

if (process.env.NODE_ENV === 'development') {
    HtmlText.propTypes = {
        as: PropTypes.oneOf(['div', 'span', 'p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
        htmlText: PropTypes.string,
        className: PropTypes.string,
        'data-testid': PropTypes.string
    };
}

export default HtmlText;
